import {pageTypes} from 'features/layout/CommonPage/redux';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import {IAdminRole} from 'types/diplomat/settings/adminroles/AdminRole';
import {IDiplomatObject} from 'types/DiplomatObject';
import {DiplomatObjectType} from 'types/DiplomatObjectType';

import {IArchiveSettings} from '../../types/ArchiveSettings';
import {AuditTrailSettings} from '../../types/AuditTrailSettings';
import {BackupSettings} from '../../types/BackupSettings';
import {EmailSettings} from '../../types/EmailSettings';
import {FTPSettings} from '../../types/FTPSettings';
import {IITSupportEmailSettings} from '../../types/ITSupportEmailSettings';
import {IJobHistorySettings} from '../../types/JobHistorySettings';
import {IJobSettings} from '../../types/JobSettings';
import {KeySettings} from '../../types/KeySettings';
import {ILogFileSettings} from '../../types/LogFileSettings';
import {PagingSettings} from '../../types/PagingSettings';
import {ISessionData} from '../../types/SessionData';
import {Action, handleAsyncActions} from '../helpers';

import types, {settingsReducerKey} from './types';

export const settingsInitialState = {
   isFetching: false,
   error: null,

   backupSettings: {} as BackupSettings,
   ftpSettings: {} as FTPSettings,
   keySettings: {} as KeySettings,
   jobHistorySettings: {} as IJobHistorySettings,
   jobSettings: {} as IJobSettings,
   archiveSettings: {} as IArchiveSettings,
   auditTrailSettings: {} as AuditTrailSettings,
   emailSettings: {} as EmailSettings,
   pagingSettings: {} as PagingSettings,
   supportEmailSettings: {} as IITSupportEmailSettings,
   logginSettings: {} as ILogFileSettings,
   sessionData: {} as ISessionData,
   adminRoles: [] as IAdminRole[],
};

const reducer = (_state = settingsInitialState, action: Action) => {
   const state = handleAsyncActions(_state, action, types);

   switch (action.type) {
      case types.GET_BACKUP_SETTINGS.SUCCESS:
         return {
            ...state,
            backupSettings: action.payload,
         };
      case types.GET_JOB_HISTORY_SETTINGS.SUCCESS:
         return {
            ...state,
            jobHistorySettings: action.payload,
         };

      case types.GET_FTP_SETTINGS.SUCCESS:
         return {
            ...state,
            ftpSettings: action.payload,
         };
      case types.GET_KEY_SETTINGS.SUCCESS:
         return {
            ...state,
            keySettings: action.payload,
         };
      case types.GET_AUDIT_TRAIL_SETTINGS.SUCCESS:
      case types.POST_AUDIT_TRAIL_SETTINGS.SUCCESS:
         return {
            ...state,
            auditTrailSettings: action.payload,
         };

      case pageTypes.SEND_DATA.SUCCESS:
         if (
            (action.payload as IDiplomatObject).objectType ===
            DiplomatObjectType.enum.EMAIL_SERVER_SETTINGS
         ) {
            return {
               ...state,
               emailSettings: action.payload,
            };
         }
         return state;
      case types.GET_EMAIL_SETTINGS.SUCCESS:
         return {
            ...state,
            emailSettings: action.payload,
         };

      case types.GET_PAGING_SETTINGS.SUCCESS:
         return {
            ...state,
            pagingSettings: action.payload,
         };

      case types.GET_JOB_SETTINGS.SUCCESS:
      case types.POST_JOB_SETTINGS.SUCCESS:
         return {
            ...state,
            jobSettings: action.payload,
         };
      case types.GET_ARCHIVE_SETTINGS.SUCCESS:
      case types.POST_ARCHIVE_SETTINGS.SUCCESS:
         return {
            ...state,
            archiveSettings: action.payload,
         };

      case types.GET_SUPPORT_EMAIL_SETTINGS.SUCCESS:
      case types.POST_SUPPORT_EMAIL_SETTINGS.SUCCESS:
         return {
            ...state,
            supportEmailSettings: action.payload,
         };

      case types.GET_LOGGING_SETTINGS.SUCCESS:
      case types.POST_LOGGING_SETTINGS.SUCCESS:
         return {
            ...state,
            logginSettings: action.payload,
         };

      case types.GET_SESSION_SETTINGS.SUCCESS:
      case types.POST_SESSION_SETTINGS.SUCCESS:
         return {
            ...state,
            sessionData: action.payload,
         };
      case types.FETCH_ADMIN_ROLES.SUCCESS:
         return {
            ...state,
            adminRoles: action.payload,
         };

      default:
         return state;
   }
};

let _reducer = reducer;
if (process.env.REACT_APP_PERSISTED === 'true') {
   const config = {
      key: settingsReducerKey,
      storage: storage,
      blacklist: ['error', 'isFetching'],
   };
   _reducer = persistReducer(config, reducer) as any;
}
export default _reducer;
